module.exports = __webpack_public_path__ + "static/media/stamp.0c0b9638.svg";